import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	prompt: {
		marginBottom: theme.spacing(2),
	},
	leadOwner: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(1),
		paddingLeft: theme.spacing(4.5),
		marginTop: theme.spacing(1),
	},
	leadOwnerHead: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
	},
	addLink: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		fontWeight: 600,
		whiteSpace: "nowrap",
	},
	note: {
		marginTop: theme.spacing(2),
	},
} satisfies Record<string, CSSObject>);
